/**
 * Admin UI lives at /admin (plus PUBLIC_URL prefix for GitHub project pages).
 * GitHub Pages needs build/index.html copied to build/404.html (see npm postbuild).
 */

function publicUrlBase() {
  const raw = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  // CRA sets PUBLIC_URL to "." when homepage is "." (host-anywhere / Firebase-style).
  // That is an asset base, not a pathname prefix; real pathnames still use "/admin".
  if (!raw || raw === '/' || raw === '.') return '';
  return raw;
}

/** Pathname for the guest-registry admin screen, e.g. "/admin" or "/repo/admin". */
export function getAdminPathname() {
  const base = publicUrlBase();
  return base ? `${base}/admin` : '/admin';
}

/** Home path for the public site (strip /admin when closing). */
export function getSiteHomePathname() {
  const base = publicUrlBase();
  return base || '/';
}

export function isAdminPathname(pathname) {
  const admin = getAdminPathname();
  const p = pathname.replace(/\/$/, '') || '/';
  const a = admin.replace(/\/$/, '') || '/';
  return p === a;
}

/** Public voicenote recorder page, e.g. "/voicenote" (same PUBLIC_URL prefix as admin when set). */
export function getVoiceNotePathname() {
  const base = publicUrlBase();
  return base ? `${base}/voicenote` : '/voicenote';
}

export function isVoiceNotePathname(pathname) {
  const vo = getVoiceNotePathname();
  const p = pathname.replace(/\/$/, '') || '/';
  const v = vo.replace(/\/$/, '') || '/';
  return p === v;
}

/** Legacy honeymoon fund pathname — SPA forwards to Monzo.me (no email gate). */
export function isHoneymoonFundPathname(pathname) {
  const base = publicUrlBase();
  const hf = base ? `${base}/honeymoon-fund` : '/honeymoon-fund';
  const p = pathname.replace(/\/$/, '') || '/';
  const h = hf.replace(/\/$/, '') || '/';
  return p === h;
}

/** Fired when the SPA pathname changes without a full reload (e.g. admin close uses replaceState). */
export const WEDDING_APP_PATH_CHANGED_EVENT = 'wedding-app-path-changed';

export function notifyAppPathChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(WEDDING_APP_PATH_CHANGED_EVENT));
  }
}
